module.exports = __webpack_public_path__ + "static/media/bg.c2b90898.png";